import { StyleSheet } from 'react-native';
import { SIZES, PALETTE, MQ_TABLET } from '../../../constants';
import { MediaQueryStyleSheet } from 'react-native-responsive';

export default MediaQueryStyleSheet.create(
  {
    bannerRoot:{
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      marginLeft: 35,
      marginRight: 35
    },
    welcomeMessage: {
      alignItems: 'center',
      justifyContent: 'center'
    },
    bannerTitle: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center'
    },
    esignImage1: {
        flex:1,
        minHeight: 130,
        marginBottom: 10,
        marginTop: 5
    },
    esignImage2: {
        flex:1,
        minHeight: 130,
        marginBottom: 5
    },
    instructionText:{
        
    },
    bannerButtons: {
        flex:0.5,
        flexDirection: 'row',
        marginTop: 30,
        marginLeft: 40,
        marginRight: 40,
        marginBottom: 10,
        justifyContent: 'center'
    },
    icon:{
      marginLeft: 5
    }
  },
  {
    [MQ_TABLET]: {
      bannerTabletImages: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 10,
        marginTop: 10,
        minHeight: 160
      },
      esignImage1: {
       
      },
      esignImage2: {
          
      },
      bannerTitle: {
        flexDirection: 'row',
        marginTop: 15,
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 20
      },
      bannerButtons: {
        flex:0.5,
        flexDirection: 'row',
        marginTop: 30,
        marginLeft: 40,
        marginRight: 40,
        marginBottom: 10,
        justifyContent: 'center'
      },
      acceptButton: {
        flex: 0.3,
      },
      notnowButton: {
        flex:0.3,
        marginRight: 10
      }
    }
  }
);
